<template>
    <v-row>
      <v-col cols="12" md="3">
        <v-row>

          <v-col id="patient-list-sidebar" cols="12">
            <v-card color="transparent" flat>
              <v-card-title id="chat-sidebar-title">Patients</v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field outlined label="Search" single-line dense prepend-inner-icon="mdi-magnify" :style="{ borderRadius: '15px' }" v-model="search" clearable ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div class="d-flex justify-space-between align-center">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" outlined depressed icon :style="{ borderRadius: '12px' }">
                            <v-icon> mdi-sort-variant </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <template v-for="(filter, index) in filterItems">
                            <v-list-item :key="index" @click="roomsOptions.status = filter.value">
                              <v-badge color="primary" dot class="font-weight-medium" v-if="roomsOptions.status === filter.value">
                                {{ filter.text }}
                              </v-badge>
                              <span v-if="roomsOptions.status !== filter.value">{{ filter.text }}</span>
                            </v-list-item>
                          </template>
                        </v-list>
                      </v-menu>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn depressed color="primary" text v-bind="attrs" v-on="on">
                            <span class="text-capitalize mr-1">
                              Sort <span class="text-lowercase">by</span>
                              {{ roomsOptions.sort }} chats
                            </span>
                            <v-icon>mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="roomsOptions.sort = 'newest'">Newest</v-list-item>
                          <v-list-item @click="roomsOptions.sort = 'oldest'">Oldest</v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-list id="chat-room-list-wrapper" rounded dense :style="{ maxHeight: '600px', overflow: 'auto'}">
                      <div class="d-flex justify-center pa-2">
                        <v-progress-circular color="grey" v-if="isGetRoomsStart" width="3" indeterminate></v-progress-circular>
                      </div>
                      <v-list-item-group v-model="selectedItem" color="#F1F1F1" v-if="!isGetRoomsStart">
                        

                        <!-- ###################################################### SIDEBAR CHAT LIST ###################################################### -->

                        <div id="chat-room-wrapper">
                          <template v-for="(room, index) in sortedRooms">
                            <v-list-item class="room-item-trigger" :key="index" active-class="font-weight-medium black--text" @click="markAsRead(room.id)" :to="{ name: 'Backroom Chat', params: { chatRoomSlug: room.slug }, }">
                              <div 
                                  :class="[
                                    'chat-instance-wrapper',
                                    isPatient(room.last_chat) ? 'unreplied' : '',
                                    isTMA(room.last_chat) ? 'replied' : '',
                                    room.unread != 0 ? 'unread' : '',
                                    room.status
                                  ]"

                                  :id="room.slug"
                                >
                                <v-list-item-content :class="room.unreadCount ? 'font-weight-medium' : ''" v-if="room.patient != undefined && room.patient.patient != null">
                                  {{ formatName(room.patient) }}
                                </v-list-item-content>
                                <v-list-item-action>
                                  <span v-if="room.unread === 0">{{ formatTime(room.updated_at) }}</span>
                                  <v-badge color="error" inline left dot v-if="room.unread > 0">
                                    <span class="font-weight-medium">
                                      {{ formatTime(room.updated_at) }}
                                    </span>
                                  </v-badge>
                                </v-list-item-action>
                              </div>

                            </v-list-item>
                          </template>
                        </div>

                        <!-- ###################################################### SIDEBAR CHAT LIST ###################################################### -->

                        <infinite-loading spinner="spiral" @infinite="loadRooms" :identifier="roomsScrollOptions.id">
                          <div slot="no-more"></div>
                          <div slot="no-results">
                            <div class="text-center py-5">
                              <span class="subtitle-2 black--text">End of list.</span>
                            </div>
                          </div>
                        </infinite-loading>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>

            </v-card>
          </v-col>


          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-col>
      
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-card
              color="#F1F1F1"
              outlined
              :style="{
                borderRadius: '15px',
                borderColor: '#999999',
              }"
            >
              <v-card-title id="chat-room-patient-name">
                <span v-if="patientInformation && patientInformation.patient != null ">{{
                  patientInformation.patient.full_name ||
                  patientInformation.username
                }}</span>
                <div class="flex-grow-1"></div>
                
                <!-- <v-tooltip
                  bottom
                  v-if="
                    chatRoomSlug &&
                    roomInformation &&
                    roomInformation.status === 'done'
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" large> mdi-check-circle </v-icon>
                  </template>
                  <span>Done Message</span>
                </v-tooltip> -->

                <!-- <v-tooltip
                  bottom
                  v-if="
                    chatRoomSlug &&
                    roomInformation &&
                    roomInformation.status === 'star'
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" large> mdi-star </v-icon>
                  </template>
                  <span>Starred Message</span>
                </v-tooltip> -->

                <v-menu offset-y v-if="chatRoomSlug && roomInformation">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon large v-bind="attrs" v-on="on">
                      <v-icon x-large>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-card :loading="isAddToStart" id="room-status-action">
                    <v-card-title class="font-weight-medium">Add to</v-card-title>
                    
                    <v-list>
                      <v-list-item dense @click="addTo(roomInformation.status === 'star' ? 'active' : 'star')"  :disabled="isAddToStart" :class="roomInformation.status === 'star' ? 'active' : ''">
                        <v-list-item-icon>
                          <v-icon> mdi-star </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>Star</v-list-item-content>
                      </v-list-item>
                      
                      <v-list-item dense @click="addTo(roomInformation.status === 'done' ? 'active' : 'done')" :disabled="isAddToStart" :class="roomInformation.status === 'done' ? 'active' : ''">
                        <v-list-item-icon>
                          <v-icon> mdi-check-circle </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>Done</v-list-item-content>
                      </v-list-item>
                    </v-list>

                  </v-card>
                </v-menu>
              </v-card-title>
            </v-card>
          </v-col>

          <v-col id="chat-window" cols="12">
            <v-card
              color="#F1F1F1"
              flat
              :style="{ borderRadius: '15px', position: 'relative' }"
            >
              <v-card-text
                class="pb-5 pt-8 px-5"
                :style="{
                  height: '570px',
                  overflow: 'auto',
                }"
                id="chats-holder"
                ref="chatsHolder"
              >
                <infinite-loading
                  direction="top"
                  spinner="spiral"
                  @infinite="loadChats"
                  :identifier="chatsIdentifier"
                  v-if="chatRoomSlug"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>

                <template v-for="(chat, index) in sortedChats">
                  
                  <!-- ###################################################### PATIENT CHAT HANDLER ###################################################### -->

                  <div class="d-flex justify-space-between mb-5" :key="index" v-if="chat.user != null && chat.user.user_type === 'patient'">
                    <div class="d-flex align-start">
                      <v-avatar color="primary" :size="45" class="#666666--text white--text mr-2 text-capitalize">{{ chat.user.username[0] || "" }}</v-avatar>
                      <div class="patient-chat">
                        <v-card
                          color="white"
                          flat
                          shaped
                          class="pre-formatted body-2 px-4 py-5 mb-2"
                          max-width="365"
                          v-html="formatMessage(chat.message)"
                        ></v-card>
                        <span class="caption">{{ formatDateTime(chat.created_at)}}</span>
                      </div>
                    </div>
                    <div class="flex-grow-1"></div>
                  </div>

                  <!-- ###################################################### PATIENT CHAT HANDLER ###################################################### -->



                  <!-- ###################################################### CSR CHAT HANDLER ###################################################### -->

                  <div class="d-flex justify-space-between mb-5" :key="index" v-if="chat.user != null && (chat.user.user_type === 'csr' || chat.user.user_type === 'tma' )">
                    <div class="flex-grow-1"></div>
                    <div class="d-flex align-start">
                      <div class="csr-chat">
                        <v-card color="#258BF5" flat shaped class="pre-formatted body-2 px-4 py-5 mb-2" max-width="365" dark v-html="formatMessage(chat.message)"></v-card>
                        <div class="d-flex justify-space-between">
                          <div class="flex-grow-1"></div>
                          <span class="caption">
                            <span class="mr-5">Sent by <span class="primary--text text-capitalize">{{ chat.user.username }}</span></span>
                            <span>{{ formatDateTime(chat.created_at) }}</span>
                          </span>
                        </div>
                      </div>
                      <v-avatar color="primary" :size="45" class="ml-2"><v-icon large color="white">mdi-account-circle</v-icon></v-avatar>
                    </div>
                  </div>

                  <!-- ###################################################### CSR CHAT HANDLER ###################################################### -->

                </template>
              </v-card-text>
              <v-card-text>
                <v-card id="chat-text-wrapper" color="white" flat :style="{ borderRadius: '15px'}" class="d-flex justify-space-between align-center pa-5 elevation-1">
                  <textarea
                    id="chat-message-holder"
                    placeholder="Enter your message here.."
                    class="mr-5"
                    v-model="chatMessage"
                  />
                  <div class="flex-grow-1"></div>
                  <div class="d-flex align-center">
                    <v-btn
                      depressed
                      color="#1665CE"
                      large
                      :style="{ borderRadius: '12px' }"
                      class="mr-3 white--text"
                      @click="sendChat"
                      :disabled="isSendChatStart || !isChatMessageValid"
                    >
                      <span class="text-capitalize mr-1">Send</span>
                      <v-icon small>mdi-play</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      
    <PatientInformation
      id="patient-information-wrapper"
      :patientInformation="patientInformation" 
      :isGetPatientInformationStart="isGetPatientInformationStart"
      :patientCases="patientCases"
      :isGetPatientCasesStart="isGetPatientCasesStart" />

    <v-dialog v-model="isCallDialogOpen" width="400">
      <v-card>
        <v-card-title>
          <span>Call</span>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="isCallDialogOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                depressed
                color="#1665CE"
                class="text-capitalize"
                block
                x-large
                dark
              >
                Call <span class="text-lowercase mx-1">via</span> App
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-checkbox color="#258BF5">
                <template v-slot:label>
                  <span class="font-weight-medium" :style="{ color: '#258BF5' }"
                    >or outside app</span
                  >
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-row dense>
                <v-col cols="8">
                  <v-text-field
                    outlined
                    placeholder="Enter Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    depressed
                    color="#EE5252"
                    dark
                    x-large
                    :style="{ borderRadius: '12px' }"
                    class="text-capitalize"
                    block
                  >
                    Call
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  CREATE_CHAT,
  GET_CHAT_ROOMS,
  GET_CHATS,
  UPDATE_CHAT,
} from "@/views/csr/store/typeDefs/chat";
import utilityMixin from "@/views/csr/mixins/utility";
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment";
import commonPusher from "@/views/csr/common/pusher";
import {
  GET_PATIENT_CASES,
  GET_PATIENT_INFORMATION,
} from "@/views/csr/store/typeDefs/patient";

import PatientInformation from './chat/PatientInformation'

export default {
  components: {
    InfiniteLoading,
    PatientInformation
  },

  /* ------------------------------------------------------- LIFECYCLE SEPARATOR ------------------------------------------------------- */

  data() {
    return {
      filterItems: [
        {
          text: "All Messages",
          value: null,
        },

        {
          text: "Unread Messages",
          value: "active",
        },

        {
          text: "Starred Messages",
          value: "star",
        },

        {
          text: "Done Messages",
          value: "done",
        },
      ],
      selectedItem: 4,
      chatColumnHeight: 0,
      isCallDialogOpen: false,
      rooms: [],
      chats: [],
      chatsPage: 1,
      chatMessage: null,
      isSendChatStart: false,
      isGetRoomsStart: false,
      chatsIdentifier: +new Date(),
      isMarkAsDoneStart: false,
      roomsOptions: {
        sort: "newest",
        status: null,
      },
      roomsScrollOptions: {
        page: 1,
        id: +new Date(),
      },
      patientInformation: null,
      patientCases: [],
      isGetPatientCasesStart: false,
      isGetPatientInformationStart: false,
      search: null,
      searchTimer: null,
      isInitialRoomsLoaded: false,
      isAddToStart: false,
    };
  },

  mixins: [utilityMixin],

  /* ------------------------------------------------------- LIFECYCLE SEPARATOR ------------------------------------------------------- */

  computed: {
    chatRoomSlug() {
      return this.$route.params.chatRoomSlug;
    },

    selectedRoom() {
      const slug = this.$route.params.chatRoomSlug;
      if (slug) return this.rooms.find((room) => room.slug === slug);
      return null;
    },

    isChatMessageValid() {
      return this.chatMessage && this.chatMessage.length >= 3;
    },

    roomInformation() {
      if (this.chatRoomSlug) {
        return this.rooms.find((chat) => chat.slug === this.chatRoomSlug);
      }
      return null;
    },

    sortedRooms() {
      const rooms = this.rooms;
      if (this.roomsOptions.sort === "newest") {
        return rooms.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        );
      }
      return rooms.sort(
        (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
      );
    },

    sortedChats() {
      const chats = this.chats;
      // chats.message = "test: " + chats.message;
      return chats.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    },
  },

  /* ------------------------------------------------------- LIFECYCLE SEPARATOR ------------------------------------------------------- */

  watch: {
    chatRoomSlug(slug) {
      if (slug) {
        this.chats = [];
        this.chatsPage = 1;
        this.chatsIdentifier += 1;
      }
    },

    async isInitialRoomsLoaded(isLoaded) {
      if (isLoaded) {
        const room = this.rooms[0];
        this.markAsRead(room.id);
        await this.$router
          .push({
            name: "Backroom Chat",
            params: { chatRoomSlug: room.slug },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(err);
            }
          });
      }
    },

    "roomsOptions.sort"(sort) {
      if (sort) {
        this.rooms = [];
        this.roomsScrollOptions = Object.assign(this.roomsScrollOptions, {
          page: 1,
          id: this.roomsScrollOptions.id + 1,
        });
      }
    },

    "roomsOptions.status"() {
      this.isInitialRoomsLoaded = false;
      this.rooms = [];
      this.roomsScrollOptions = Object.assign(this.roomsScrollOptions, {
        page: 1,
        id: this.roomsScrollOptions.id + 1,
      });
    },

    async selectedRoom(val) {
      if (val) {
        await this.getPatientInformation();
        await this.getPatientCases();
      }
    },

    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.rooms.map((room) =>
          commonPusher.getPusher().unsubscribe(`chat-${room.slug}`)
        );
        this.rooms = [];
        this.roomsScrollOptions = Object.assign(
          {},
          {
            id: this.roomsScrollOptions.id + 1,
            page: 1,
          }
        );
      }, 800);
    },
  },

  /* ------------------------------------------------------- LIFECYCLE SEPARATOR ------------------------------------------------------- */

  methods: {
    isPatient(lastChat) {
      return lastChat && lastChat.user && lastChat.user.user_type === 'patient';
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */
    
    isTMA(lastChat) {
      return lastChat && lastChat.user && lastChat.user.user_type !== 'patient';
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    formatMessage(message) {
      if (!message) return "";
      try {
        // Parse the message only if it's valid JSON
        const parsedMessage = JSON.parse(message);
        const formattedMessage = parsedMessage.replace(/\\n/g, "<br>").replace(/\n/g, "<br>");
        return formattedMessage;
      } catch (error) {
        // If the message is not valid JSON, return it as-is
        // console.warn("Invalid JSON message:", error);
        return message;
      }
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async loadRooms($state) {
      const payload = {
        page: this.roomsScrollOptions.page,
        sort: this.roomsOptions.sort,
        search: this.search,
        status: this.roomsOptions.status,
      };
      const gotRooms = await this.$store.dispatch(GET_CHAT_ROOMS, payload);
      this.listenToNewMessages(gotRooms);
      this.saveRoomsCache(gotRooms);
      this.rooms = [...this.rooms, ...gotRooms];
      this.identifyUnreadMessages();
      if (gotRooms.length === 15) {
        $state.loaded();
        if (this.roomsScrollOptions.page === 1)
          this.isInitialRoomsLoaded = true;
        this.roomsScrollOptions.page += 1;
      } else {
        this.isInitialRoomsLoaded = true;
        $state.complete();
      }
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async loadChats($state) {
      console.log("loadChats");
      const payload = { slug: this.chatRoomSlug, page: this.chatsPage };
      const gotChats = await this.$store.dispatch(GET_CHATS, payload);
      this.chats = [...gotChats, ...this.chats];
      if (gotChats.length === 15) {
        if (this.chatsPage === 1) this.scrollToBottom();
        $state.loaded();
        this.chatsPage += 1;
      } else {
        if (this.chatsPage === 1) this.scrollToBottom();
        $state.complete();
      }
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    formatDateTime(dateTime) {
      return dateTime ? moment(dateTime).format("l [at] h:mmA") : "";
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async sendChat() {
      console.log("sendChat");
      if (this.chatMessage) {
        const payload = {
          slug: this.chatRoomSlug,
          message: this.chatMessage.trim(),
        };
        this.isSendChatStart = true;
        const createdChat = await this.$store.dispatch(CREATE_CHAT, payload);
        this.isSendChatStart = false;
        if (createdChat) {
          this.isSendChatStart = false;
          this.chatMessage = null;

          console.log("createdChat: ", createdChat);

          this.rooms = this.rooms.map((item, index) => {
            if (item.slug === createdChat.slug) {
              // item.last_chat = createdChat;
              
              console.log("this.rooms[index] from sendChat", this.rooms[index]);
              this.rooms[index].last_chat = createdChat;

              console.log("this.rooms[index] from sendChat after alter", this.rooms[index]);
            }
            return item;
          });


          return;
        }
        this.isSendChatStart = false;
      }
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    scrollToBottom() {
      this.$nextTick(() => {
        const chatsHolder = this.$refs.chatsHolder;
        chatsHolder.scrollTop = chatsHolder.scrollHeight;
      });
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async addTo(status) {
      const payload = {
        roomID: this.roomInformation.id,
        status: status,
      };
      this.isAddToStart = true;
      const { success, data } = await this.$store.dispatch(
        UPDATE_CHAT,
        payload
      );
      if (success) {
        this.rooms = this.rooms.map((room) => {
          if (room.slug === data.slug) {
            room = Object.assign(room, data);
          }
          return room;
        });
        this.isAddToStart = false;
        return;
      }
      this.isAddToStart = false;
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    listenToNewMessages(rooms) {
      rooms.forEach((room) => {
        const channel = commonPusher.getPusher().subscribe(`chat-${room.slug}`);
        channel.bind("new-message", (chat) => {
          
          console.log("listenToNewMessages chat", chat);
          console.log("listenToNewMessages: room", room);

          this.rooms = this.rooms.map((item, index) => {
            if (item.slug === chat.chat_room.slug) {
              this.rooms[index].last_chat = chat;

              console.log("this.rooms[index] from listen to new message", this.rooms[index]);
              item = Object.assign(item, {
                updated_at: chat.updated_at,
              });
            }
            return item;
          });


          // to append newly created message to the current chats under the matched chatroom
          if (chat.chat_room.slug === this.chatRoomSlug) {
            this.updateRoomsCache(room.slug, chat.id);
            console.log("this.chats: ", this.chats);
            this.chats = [...this.chats, chat];
            this.scrollToBottom();
            return;
          }

          this.rooms = this.rooms.map((item, index) => {
            if (item.slug === chat.chat_room.slug) {
              console.log("this.rooms[index] from listenToNewMessages: ", this.rooms[index]);
              this.rooms[index].last_chat = chat;
              item = Object.assign(item, {
                last_chat: chat,
                unread: (item.unread += 1),
                updated_at: chat.updated_at,
              });
            }
            return item;
          });

        });
      });
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    listenToNewRooms() {
      const chatRoomChannel = commonPusher.getPusher().subscribe("chat-room");
      chatRoomChannel.bind("created", (room) => {
        if (room) {
          console.log("new room created:", room);
          
          this.saveRoomsCache([room]);
          room = Object.assign(room, { unread: 0 });
          this.rooms = [room, ...this.rooms];

          const newRoomChannel = commonPusher.getPusher().subscribe(`chat-${room.slug}`);
          newRoomChannel.bind("new-message", (chat) => {

            console.log("current chat room: ", `chat-${room.slug}`);
            console.log("new message was sent:", chat);

            this.rooms = this.rooms.map((item) => {
              if (item.slug === chat.chat_room.slug) {

                if (chat.chat_room.slug === this.chatRoomSlug) {
                  item = Object.assign(item, {
                    updated_at: chat.updated_at,
                  });
                } else {
                  item = Object.assign(item, {
                    unread: (item.unread += 1),
                    updated_at: chat.updated_at,
                  });
                }
                item.last_chat = chat;
              }
              return item;
            });

            if (chat.chat_room.slug === this.chatRoomSlug) {
              this.updateRoomsCache(chat.chat_room.slug, chat.id);
              console.log("this.chats: ", this.chats);
              this.chats = [...this.chats, chat];
              this.scrollToBottom();
              return;
            }
          });
        }
      });
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async getPatientInformation() {
      this.isGetPatientInformationStart = true;
      const patientID = this.selectedRoom.patient.id;
      this.patientInformation = await this.$store.dispatch(
        GET_PATIENT_INFORMATION,
        patientID
      );
      this.isGetPatientInformationStart = false;
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    async getPatientCases() {
      this.isGetPatientCasesStart = true;
      const patientID = this.selectedRoom.patient.id;
      this.patientCases = await this.$store.dispatch(
        GET_PATIENT_CASES,
        patientID
      );
      this.isGetPatientCasesStart = false;
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    formatName(user) {
      let name = null;
      let firstName = user.patient.first_name;
      let lastName = user.patient.last_name;

      if (user.patient.full_name != null && user.patient.full_name.trim() != '') {
        name = user.patient.full_name.trim();
      } else if (firstName && lastName) {
        name = `${firstName} ${lastName}`;
      } else if (firstName && !lastName) {
        name = `${firstName}`;
      } else if (!firstName && lastName) {
        name = `${lastName}`;
      } else {
        name = user.username || user.email;
      }

      return name;
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    saveRoomsCache(rooms) {
      rooms.map((room) => {
        const roomsCache =
          JSON.parse(localStorage.getItem("rooms-cache")) || [];
        const roomCache =
          roomsCache.find((cache) => cache.roomSlug === room.slug) || null;
        if (!roomCache) {
          const payload = {
            roomSlug: room.slug,
            chatId: room.last_chat ? room.last_chat.id : null,
          };
          const newRoomsCache = [...roomsCache, payload];
          localStorage.setItem("rooms-cache", JSON.stringify(newRoomsCache));
        }
      });
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    updateRoomsCache(roomSlug, chatId) {
      let roomsCache = JSON.parse(localStorage.getItem("rooms-cache")) || [];
      let roomCache =
        roomsCache.find((cache) => cache.roomSlug === roomSlug) || null;
      if (roomCache) {
        let newRoomsCache = roomsCache.map((_roomCache) => {
          if (_roomCache.roomSlug === roomSlug)
            _roomCache = Object.assign(_roomCache, { chatId });
          return _roomCache;
        });
        localStorage.setItem("rooms-cache", JSON.stringify(newRoomsCache));
      }
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    identifyUnreadMessages() {
      this.rooms = this.rooms.map((room) => {
        const roomsCache =
          JSON.parse(localStorage.getItem("rooms-cache")) || [];
        const roomCache =
          roomsCache.find((cache) => cache.roomSlug === room.slug) || null;
        let unread = 0;
        if (roomCache.chatId && roomCache.chatId !== room.last_chat.id)
          unread++;
        room = Object.assign(room, { unread });
        return room;
      });
    },

    /* ######################################## FUNCTION SEPARATOR ######################################## */

    markAsRead(id) {
      this.rooms = this.rooms.map((room) => {
        if (room.id === id) {
          try {
            this.updateRoomsCache(room.slug, room.last_chat.id);
          } catch (error) {
            console.log(error)
          }
          room = Object.assign(room, { unread: 0 });
        }
        return room;
      });
    },
  },

  /* ######################################## FUNCTION SEPARATOR ######################################## */

  async created() {
    this.listenToNewRooms();
  },

};
</script>

<style lang="scss">
  .pre-formatted {
    white-space: break-spaces;
  }
  
  #chat-message-holder {
    width: 100%;
    height: 80px;
    outline: none;
    padding: 10px;
  }

  #chat-text-wrapper {
    min-height: 100px;
  }

  .chat-instance-wrapper {
    width: 100%;
    float: left;
  }

  .chat-instance-wrapper .v-list-item__content { float: left; }
  .chat-instance-wrapper .v-list-item__action { float: right; }

  a:has(.chat-instance-wrapper) {
    background-color: #ccc;
  }

  a:has(.chat-instance-wrapper.unreplied) {
    background: #258bf5;
  }

  a:has(.chat-instance-wrapper.unreplied) * { color: #fff; }
  a:has(.chat-instance-wrapper.done) { background: #30b18a; }
  a:has(.chat-instance-wrapper.star) { background: #FFD700; }
  a:has(.chat-instance-wrapper.unread) { background: #b3597c !important; }

  #chat-sidebar-title { padding-top: 0px !important; }

  .table * { text-align: left; }
  .table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }

  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
  }

  .table tbody + tbody {
    border-top: 2px solid #dee2e6;
  }

  .table-bordered {
    border: 1px solid #dee2e6;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6;
  }

  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .table-striped tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  #room-status-action .active { background: #b3597c !important; }
  #room-status-action .active * { color: #fff; }
  #room-status-action .v-list-item__icon { margin-right: 10px !important; }

  #patient-action-wrapper {
    margin-top: 10px;
    border-top: 1px solid #ccc;
    padding-top: 10px;
  }

  .btn.patient-instance-action {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 5px;
    text-decoration: none;
  }

  .btn-primary.patient-instance-action {
    color: #fff;
    background-color: #258bf5 !important;
    border-color: #258bf5 !important;
    box-shadow: none;
  }

  .btn-info.patient-instance-action {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
    box-shadow: none;
  }
</style>